module.exports = __webpack_public_path__ + "static/media/mall.39a14973.png";